import { render } from "./InquiryForm.vue?vue&type=template&id=55363862&scoped=true"
import script from "./InquiryForm.vue?vue&type=script&lang=js"
export * from "./InquiryForm.vue?vue&type=script&lang=js"

import "./InquiryForm.vue?vue&type=style&index=0&id=55363862&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55363862"]])

export default __exports__